export class QuoteAgreementStatus {
    static DRAFT = 100;

    static ACCEPTED = 200;

    static REJECTED = 300;
}
